module.exports = __webpack_public_path__ + "static/co_founder_mobile_header-8a80c716322c6b81d0491c240434aa3c.png";